import { useMutation, useQuery } from '@tanstack/react-query';
import { ChatChannel } from '@stores';
import api from '@api/http/api';

export function useSendMessageMutation() {
  return useMutation<{ success: true }, {}, { channelId?: string; content: string }>({
    mutationFn: (values) => api.post('/chat/send', values),
  });
}

export function useLeaveChannelMutation() {
  return useMutation<{ success: true }, {}, { channelId: string }>({
    mutationFn: (values) => api.post('/chat/leave', values),
  });
}

export function useDeleteChatMessageMutation() {
  return useMutation<{ success: true }, {}, { id: string }>({
    mutationFn: (values) => api.post('/chat/delete', values),
  });
}

export function useChatBanUserMutation() {
  return useMutation<{ success: true }, {}, { id: string }>({
    mutationFn: (values) => api.post('/chat/ban', values),
  });
}

export function useWhisperMutation() {
  return useMutation<ChatChannel, {}, { id: string }>({
    mutationFn: (values) => api.post('/chat/whisper', values),
  });
}

export function useChatQuery() {
  return useQuery<any>({
    queryFn: () => api.get('/chat'),
    queryKey: ['chat'],
  });
}
